
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export function FAQSection() {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const questions = t('contact.faq.questions', { returnObjects: true }) as Array<{
    question: string;
    answer: string;
  }>;

  const toggleQuestion = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  // Split questions into two columns for masonry layout
  const midpoint = Math.ceil(questions.length / 2);
  const leftColumnQuestions = questions.slice(0, midpoint);
  const rightColumnQuestions = questions.slice(midpoint);

  const renderQuestionCard = (item: { question: string; answer: string }, index: number) => (
    <div
      key={index}
      className="bg-gray-800 rounded-2xl border border-gray-700 overflow-hidden transition-ball duration-300 hover:border-yellow-400/50 mb-6"
    >
      <button
        onClick={() => toggleQuestion(index)}
        className="w-full px-6 py-5 flex items-center justify-between text-left cursor-pointer hover:bg-gray-700/50 transition-colors"
      >
        <h3 className="text-lg font-bold text-white pr-4">{item.question}</h3>
        <i
          className={`ri-arrow-down-s-line text-2xl text-yellow-400 flex-shrink-0 transition-transform duration-300 ${
            openIndex === index ? 'rotate-180' : ''
          }`}
        ></i>
      </button>
      <div
        className={`overflow-hidden transition-ball duration-300 ${
          openIndex === index ? 'max-h-96' : 'max-h-0'
        }`}
      >
        <div className="px-6 pb-5">
          <p className="text-gray-300 leading-relaxed">{item.answer}</p>
        </div>
      </div>
    </div>
  );

  return (
    <section id="faq" className="py-12 sm:py-16 lg:py-20 bg-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">{t('contact.faq.title')}</h2>
          <p className="text-gray-400 text-lg">{t('contact.faq.subtitle')}</p>
        </div>

        {/* Mobile: Single column */}
        <div className="block md:hidden">
          {questions.map((item, index) => renderQuestionCard(item, index))}
        </div>

        {/* Desktop: Masonry grid with independent columns */}
        <div className="hidden md:grid md:grid-cols-2 md:gap-6">
          {/* Left Column */}
          <div>
            {leftColumnQuestions.map((item, index) => renderQuestionCard(item, index))}
          </div>
          
          {/* Right Column */}
          <div>
            {rightColumnQuestions.map((item, index) => renderQuestionCard(item, midpoint + index))}
          </div>
        </div>
      </div>
    </section>
  );
}
